<template>
  <v-card>
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-toolbar-title>{{ $t('vsd-text-1') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn light icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row justify="end">
        <div class="pa-3">
          <v-btn color="color-grey" depressed right text small @click="$emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </div>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row justify="center">
        <v-col class="shrink">
          <v-icon :size="170" color="color-new-title-green">
            far fa-check-circle
          </v-icon>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col class="text-center">
          <h3 class="mb-0 mt-3 text-h3">{{ $t('vsd-text-1') }}</h3>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="8">
          <p class="mb-0">{{ $t('vsd-text-2') }}</p>
          <p class="font-weight-bold">
            {{ verdictData.Email }}
          </p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="9">
          <v-card outlined>
            <v-container>
              <v-row align="center">
                <v-col class="shrink ml-3">
                  <v-icon large>fas fa-info-circle</v-icon>
                </v-col>
                <v-col>
                  <p>{{ $t('vsd-text-3') }}</p>
                  <p>{{ $t('vsd-text-4') }}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="text-center">
        <shared-customer-feedback :orderNr="verdictData.OrderNr" :type="6" @close="$emit('close')"></shared-customer-feedback>
      </v-row>
      <v-row justify="center">
        <div class="pa-3">
          <v-btn tile outlined color="color-grey" class="wide-button" @click="$emit('close')">
            <span>{{ $t('close') }}</span>
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    computed: {
      verdictData () {
        return this.$store.getters.verdictData
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "vsd-text-1": "Dokumentti lähetetty",
  "vsd-text-2": "Kiitos! Sähköinen allekirjoitus onnistui, ja olemme lähettäneet ratkaisun tiedot osoitteeseen",
  "vsd-text-3": "Sähköposti on lähetetty sinulle salattuna - saat liitteen auki klikaamalla viestissä olevaa linkkiä.",
  "vsd-text-4": "Mikäli et näe viestiä, tarkista että se ei ole vahingossa päätynyt roskapostikansioon."
  },
  "se": {
  "vsd-text-1": "Dokumentet har skickats",
  "vsd-text-2": "Tack! Den elektroniska identifieringen lyckades och vi har skickat uppgifterna till e-postadressen",
  "vsd-text-3": "Meddelandet har skickats till dig som ett konfidentiellt e-postmeddelande - du öppnar bilagan genom att klicka på länken som finns i meddelandet.",
  "vsd-text-4": "Om du inte hittar meddelandet, kontrollera att det inte i misstag har hamnat i skräppostmappen."
  },
  "en": {
  "vsd-text-1": "Document has been sent",
  "vsd-text-2": "Thank you! Authentication was successful, and we have sent the court's decision to",
  "vsd-text-3": "The email will be delivered as a protected message - you can view its contents by following the link included in the message.",
  "vsd-text-4": "If you have not received the message, please make sure your email client has not classified it as spam."
  }
  }
</i18n>
